var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.913558 3.29822C0.912 2.48892 0.911221 2.08427 1.07953 1.86089C1.22616 1.66628 1.45062 1.5456 1.69382 1.53061C1.97299 1.5134 2.31011 1.73721 2.98435 2.18483L11.7585 8.00993C12.3157 8.3798 12.5942 8.56473 12.6916 8.79831C12.7768 9.00253 12.7772 9.23222 12.6928 9.43676C12.5964 9.67072 12.3185 9.85672 11.7628 10.2287L3.01111 16.0876C2.3386 16.5378 2.00234 16.7629 1.72311 16.7468C1.47986 16.7327 1.25494 16.6129 1.10756 16.4188C0.938387 16.1961 0.937608 15.7915 0.93605 14.9822L0.913558 3.29822Z",
    stroke: "#4A5463",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.6d1672e6138da2c25f2d51240b99ba7d.svg";
export { ForwardRef as ReactComponent };